export {default} from './tooltip-trigger';
